import React from "react";

const NewsletterSignupForm = () => (
  <div id="mc_embed_signup" className="newsletter-signup">
    <form
      action="https://andyet.us9.list-manage.com/subscribe/post?u=faa323952110d5be6830f05f5&id=6428bca796"
      method="post"
      id="mc-embedded-subscribe-form"
      name="mc-embedded-subscribe-form"
      target="_blank"
      noValidate
      className="validate content-left-aligned"
    >
      <fieldset id="mc_embed_signup_scroll">
        <p>
          Periodically, we offer some extra goodies to our mailing list members, including trial plans, beta features, as well as discounts on our development and consulting services.
        </p>
        <div className="form-element mc-field-group">
          <input
            id="smce-EMAIL"
            name="EMAIL"
            type="email"
            required="required"
            placeholder="Email address"
            className="form-input"
          />
        </div>
        <div id="mce-responses">
          <div
            className="response"
            id="mce-error-response"
            style={{ display: "none" }}
          />
          <div
            className="response"
            id="mce-success-response"
            style={{ display: "none" }}
          />
        </div>
        <div
          style={{ position: "absolute", left: "-5000px" }}
          aria-hidden="true"
        >
          <input
            type="text"
            name="b_faa323952110d5be6830f05f5_6428bca796"
            tabIndex="-1"
            value=""
          />
        </div>
        <div className="pull-right">
          <input
            type="submit"
            value="Join our mailing list"
            name="subscribe"
            id="mc-embedded-subscribe"
            className="button button-cta"
          />
        </div>
      </fieldset>
    </form>
  </div>
);

export default NewsletterSignupForm;
